import { render } from "./LoadingSpinner.vue?vue&type=template&id=f95853de&scoped=true"
import script from "./LoadingSpinner.vue?vue&type=script&lang=js"
export * from "./LoadingSpinner.vue?vue&type=script&lang=js"

import "./LoadingSpinner.vue?vue&type=style&index=0&id=f95853de&scoped=true&lang=css"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f95853de"]])

export default __exports__